module.exports = __webpack_public_path__ + "static/media/form_paging.15522603.svg";